import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "MedCost",
  shortName: "MedCost",
  slug: "medcost-insurance",
  seoTitle: "MedCost TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have MedCost insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your MedCost plan in Coral Springs, FL.",
  seoKeywords:
    "MedCost TMS coverage, MedCost TMS therapy, MedCost depression treatment Florida, MedCost mental health benefits Coral Springs FL, MedCost SAINT TMS",
  planType: "third-party administrator (TPA) health benefits plan",
  planRegion: "North Carolina and surrounding regions",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "MedCost is a third-party administrator (TPA) that manages health benefit plans for employers, primarily in North Carolina. MedCost plans typically include behavioral health benefits that may cover TMS therapy when medical necessity criteria are met. Because MedCost administers self-funded employer plans, coverage for TMS, accelerated TMS protocols, and other advanced depression treatments depends on the specific employer's plan design, the underlying network, and documented medical necessity.",
  officialResourceUrl: "https://www.medcost.com/",
  officialResourceLabel: "MedCost official website",
};

export const MedCostInsurance = () => <InsurancePageTemplate config={config} />;
export default MedCostInsurance;
